// (c) Copyright Mimic Networks, Inc. 2024
//
import clsx from 'clsx'
import React from 'react'

const Button = ({ label, className, ...props }) => {
  return (
    <button
      className={clsx(
        className,
        'bg-mimic-black text-mimic-white flex items-center justify-center h-8 rounded px-6 hover:opacity-90',
        'disabled:bg-gray-400 disabled:cursor-not-allowed disabled:opacity-80'
      )}
      {...props}
    >
      {label}
    </button>
  )
}

export default Button
